
const removeAuth = () =>{
    localStorage.removeItem('userData')
    localStorage.removeItem('accessToken');
  }
  const Subscription=()=>{
    window.location.href = '/subscription-list';
  }
  export {removeAuth,Subscription}